/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme, lighten, darken } from '@mui/material'
import { PaletteColors, BaseSubColors } from '../interfaces/colors'
import { isString } from './validations'

/**
 * Returns color value into the theme palette,
 * otherwise returns the original color value
 * @param theme
 * @param color
 * @param subColor
 * @returns string
 */
export const getPaletteColor = (
  theme: Theme,
  color: PaletteColors | string = 'primary',
  subColor: BaseSubColors = 'main'
): string => {
  const colorsMap: any = {
    default: theme.palette.text.primary,
    inherit: theme.palette.text.secondary
  }

  const newColor: string = colorsMap[color] || color

  let colorValue = newColor
    .split('.')
    .reduce((selector: any, key: string) => selector?.[key], theme.palette)

  if (typeof colorValue === 'object') {
    return colorValue[subColor]
  }

  if (colorValue === undefined) {
    colorValue = newColor
  }

  if (subColor !== 'main' && isString(colorValue)) {
    if (subColor === 'contrastText') {
      colorValue = theme.palette.getContrastText(colorValue)
    }
    if (subColor === 'light') {
      colorValue = lighten(colorValue, 0.25)
    }
    if (subColor === 'dark') {
      colorValue = darken(colorValue, 0.25)
    }
  }

  return isString(colorValue) ? colorValue : newColor
}

export const isMUIColor = (
  color: string,
  excludeBaseColors: boolean = false
): boolean => {
  const baseColors = ['primary', 'secondary']
  const otherColors = ['error', 'info', 'success', 'warning']

  return excludeBaseColors
    ? otherColors.includes(color)
    : baseColors.includes(color) || otherColors.includes(color)
}

export default getPaletteColor
